// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://basescan.org/address/0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee
export const GHO_TOKEN = '0x6Bb7a212910682DCFdbd5BCBb3e28FB4E8da10Ee';

// https://basescan.org/address/0x98217A06721Ebf727f2C8d9aD7718ec28b7aAe34
export const GHO_CCIP_TOKEN_POOL = '0x98217A06721Ebf727f2C8d9aD7718ec28b7aAe34';

// https://basescan.org/address/0xC5BcC58BE6172769ca1a78B8A45752E3C5059c39
export const GHO_AAVE_CORE_STEWARD = '0xC5BcC58BE6172769ca1a78B8A45752E3C5059c39';

// https://basescan.org/address/0x3c47237479e7569653eF9beC4a7Cd2ee3F78b396
export const GHO_BUCKET_STEWARD = '0x3c47237479e7569653eF9beC4a7Cd2ee3F78b396';

// https://basescan.org/address/0xB94Ab28c6869466a46a42abA834ca2B3cECCA5eB
export const GHO_CCIP_STEWARD = '0xB94Ab28c6869466a46a42abA834ca2B3cECCA5eB';

// https://basescan.org/address/0x8513e6F37dBc52De87b166980Fa3F50639694B60
export const RISK_COUNCIL = '0x8513e6F37dBc52De87b166980Fa3F50639694B60';

export const CHAIN_ID = 8453;
